export default __webpack_public_path__ + "static/media/carousel-left.3bfc5caa.svg";